import { BadgePropertiesType } from "@website/ui/badge/badge.types";
import { FC, memo } from "react";

const Badge: FC<BadgePropertiesType> = (properties) => {
  const { content, color = "primary", className } = properties;
  return (
    <span
      className={`border-on-color-high-emphasis inline-block size-2 rounded-full border ${
        color === "primary"
          ? "bg-primary"
          : color === "secondary"
            ? "bg-secondary"
            : "bg-success"
      } ${
        content
          ? "text-mini-badge text-on-color-high-emphasis flex h-4 w-max min-w-[16px] items-center justify-center px-1 py-[2px]"
          : ""
      } ${className ?? ""}`}
    >
      {content}
    </span>
  );
};

const BadgeMemoized = memo(Badge);
export { BadgeMemoized as Badge };
